import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '30vh',
    background: `linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 0%), url(${process.env.PUBLIC_URL}/images/productsimage2.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '50vh',
      backgroundPosition: 'center',
    },
  },
  ctaText: {
    width: '50vw',
    marginLeft: 'auto',
    marginRight: 'auto',
    color: 'white',
    fontSize: '1.5rem',
    textAlign: 'center',
    display: 'block',
    paddingTop: '5vh',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      paddingTop: '20vh',
      fontSize: '1.2rem',
    },
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      paddingTop: '10vh',
      fontSize: '1.2rem',
    },
  }
}));

const SOLUTIONS_TEXT = `
  We partner with content owners and media service vendors to streamline distribution workflows,
  improve delivery metrics, and significantly reduce distribution costs. With our expertise, 
  you can scale your operations confidently and efficiently, ensuring your content reaches its audience seamlessly.
`;

export default function HeadSection() {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Typography variant="h6" className={classes.ctaText}>{SOLUTIONS_TEXT}</Typography>
    </div>
  );
}
